import store from "./store";
import axios from "axios";

export const logout = async () =>
{
    try
    {
        await fetch(`${process.env.VUE_APP_ACCOUNTS_URL}/api/v1/Session/Delete`, { method: "GET", mode: "cors", credentials: "include" });
        location.href = `${process.env.VUE_APP_PUBLIC_URL}/v1/Session/Logout`;
    }

    catch(error)
    {
        console.log(error)
    }
}

const options =
{
    baseURL: `${process.env.VUE_APP_API_URL}`,
    withCredentials: true
}

let request = axios.create(options);

request.interceptors.request.use((config) =>
{
    store.commit("updateState", {name: "loading", value: true});
    return config;
});

request.interceptors.response.use((response) =>
{
    store.commit("updateState", {name: "loading", value: false});
    return response;
},
async (error) =>
{
    console.log(error);
    store.commit("updateState", {name: "loading", value: false});

    if([401].indexOf(error.response.status) >= 0)
    {
        location.href = `${process.env.VUE_APP_ACCOUNTS_URL}/login?redirect`
    }

    return Promise.reject(error);
});

export default request;